<div
  [attr.id]="entryElementId"
  [ngClass]="['row', 'level-'+indent]"
  [class.sync-photo-issue-target]="entryInstanceKey === focusEntryKey">
  <ng-container *ngIf="item.control && item.control.length; else noControl">
    <ng-container *ngIf="indent === 0" [ngTemplateOutlet]="itemLabel"></ng-container>
    <div class="controls-column">
      <ng-container *ngFor="let control of item.control; let idx = index; trackBy: trackByControl">
        <dynamic-control
          [control]="control"
          [form]="group"
          [label]="control.label || (indent === 0 ? '': (item.displayName || item.name))"
          [customLabel]="item.customLabel"
          [customValue]="item.customValue"
          [controlName]="(previewMode ? control.id.toString() : control?.templateFormControlId?.toString()) || ''"
          [value]="control.value ?? ''"
          [description]="item.showDescription && indent > 0 ? item.description : ''"
          [isFailure]="(isFailureValue$ | async)"
          [readonly]="readonly"
          [task]="task"
          [previewMode]="previewMode"
          [index]="idx"
          [failureCodes]="item.failureCodeList"
          (valueChanged)="valueChanged($event)"
          (failureHistoryEvent)="showFailuresHistory()"
          [validationRefreshTick]="validationRefreshTick"
          [forceRequired]="blocked && isNotesEntry"
          ></dynamic-control>
        </ng-container>
    </div>
    <ng-container *ngIf="(isFailureValue$ | async)">
      <div class="defects-box" [class.box-error]="hasNoDefects() && !readonly">
        <div class="defects-header">
          <span class="defects-header-label">{{ 'DEFECTS.LABEL' | translate }}</span>
          <button *ngIf="!readonly" type="button" mat-flat-button color="primary" (click)="registerFailure()">
            <mat-icon>add_circle</mat-icon>
            {{ 'ADD' | translate }}
          </button>
        </div>

        <ng-container *ngIf="hasDefects(); else noDefectsTemplate">
          <failure-item
            *ngFor="let item of failureDescription.value; index as i; let last = last; trackBy: trackByFailure"
            [index]="i"
            [last]="last"
            [item]="item"
            (editFailureEvent)="editFailure($event)"
          ></failure-item>
        </ng-container>
        <ng-template #noDefectsTemplate>
          <i>{{ 'NO_DEFECTS' | translate }}</i>
        </ng-template>
      </div>
      <div class="error-wrapper" *ngIf="hasNoDefects() && !readonly">
        <div class="fake-error">{{ 'ADD_AT_LEAST_ONE_DEFECT' | translate }}</div>
      </div>
    </ng-container>

    <div class="divider"></div>
  </ng-container>
</div>

<ng-template #noControl>
  <div class="flexible-column">
    <ng-container [ngTemplateOutlet]="itemLabel"></ng-container>
  </div>
</ng-template>
<ng-template #itemLabel>
  <div class="name">{{ item.displayName || item.name }}</div>
  <item-description *ngIf="item.showDescription" [description]="item.description"></item-description>
</ng-template>
<ng-container *ngIf="item.children?.length" >
  <dynamic-form-item
    *ngFor="let child of item.children; trackBy: trackByEntry"
    [form]="group"
    [item]="child"
    [indent]="indent + 1"
    [defectsNo]="defectsNo"
    [task]="task"
    [readonly]="readonly"
    [previewMode]="previewMode"
    [parentEntry]="item"
    [failureId]="failureId"
    [focusEntryKey]="focusEntryKey"
    [validationRefreshTick]="validationRefreshTick"
    >
  </dynamic-form-item>
</ng-container>
